import { useCallback, useEffect, useRef, useState } from "react";
import { IComboBox, IComboBoxOption } from "@fluentui/react";
import { IEquipoComboRequest } from "../../../Interfaces/IEquipo";
import { EquipoService } from "../../../services/auxiliar/EquipoService";

interface UbicacionProps {
    isOpen: boolean;
    equipoAuxiliar?: boolean
}

const UseComboEquipo = (props: UbicacionProps) => {
    const controllerRef = useRef<AbortController>(new AbortController());
    const [filterEquipo, setFilterEquipo] = useState<IEquipoComboRequest>({
        skip: 0,
        take: 20,
        search: "",
        equipoAuxiliar: props.equipoAuxiliar ?? false
    });
    const [dataComboEquipo, setDataComboEquipo] = useState<IComboBoxOption[]>([]);
    const comboBoxRefEquipo = useRef<IComboBox>(null);

    const onClickComboEquipo = () => comboBoxRefEquipo.current?.focus(true);

    const onChangeEquipo = (value: any) => {
        setFilterEquipo({ ...filterEquipo, search: value });
    }
    const _onkeyUpSearchEquipo = (event: React.KeyboardEvent<IComboBox>) => {
        if (event.code === "Escape") {
            comboBoxRefEquipo.current?.focus(false);
            setFilterEquipo({
                skip: 0,
                take: 20,
                search: "",
                equipoAuxiliar: props.equipoAuxiliar ?? false
            });
        } else {
            let { value } = event?.target as HTMLInputElement;
            setFilterEquipo({ ...filterEquipo, search: value });
        }
    };

    const listarCombo = () => {
        controllerRef.current.abort();
        const newController = new AbortController();
        controllerRef.current = newController;
        EquipoService.ComboEquipo(filterEquipo, newController).then((res) => {
            if (res.status === 200) {
                setDataComboEquipo(res.data);
            }
        });
    };

    useEffect(() => {
        if (filterEquipo.search != "") {
            listarCombo()
        }
    }, [filterEquipo.search])

    useEffect(() => {
        if (props.isOpen) {
            listarCombo();
        }
    }, [props.isOpen]);

    return {
        dataComboEquipo,
        onClickComboEquipo,
        _onkeyUpSearchEquipo,
        comboBoxRefEquipo,
        setFilterEquipo,
        filterEquipo,
        onChangeEquipo
    };
}

export { UseComboEquipo }